import { kgToLbs, lbsToKg, cmToFtIn, ftInToCm, round } from "../dataStore"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    age: null,
    weightKg: null,
    weightLbs: null,
    heightCm: null,
    heightFt: null,
    heightIn: null,
    firstName: null,
    targetWeightKg: null,
    targetWeightLbs: null,
  },

  skipValidationsFor: ["targetWeightKg", "targetWeightLbs"],

  onInit() {
    Alpine.effect(() => {
      if (this.store.isMetric) {
        const imperialHeight = cmToFtIn(this.formValues.heightCm)

        this.formValues.weightLbs = round(kgToLbs(this.formValues.weightKg)) || 0
        this.formValues.heightFt = imperialHeight.heightFt || 0
        this.formValues.heightIn = imperialHeight.heightIn || 0
      } else {
        this.formValues.weightKg = round(lbsToKg(this.formValues.weightLbs)) || 0
        this.formValues.heightCm =
          ftInToCm({
            ft: this.formValues.heightFt,
            inch: this.formValues.heightIn,
          }) || 0
      }
    })

    Alpine.effect(() => {
      if (this.formValues.heightCm || this.formValues.heightFt || this.formValues.heightIn) {
        this.formValues.targetWeightKg = null
        this.formValues.targetWeightLbs = null
      }
    })
  },

  processFormValues() {
    if (this.store.isMetric) {
      const imperialHeight = cmToFtIn(this.formValues.heightCm)

      return {
        age: parseInt(this.formValues.age),
        weightKg: parseInt(this.formValues.weightKg),
        weightLbs: round(kgToLbs(this.formValues.weightKg)),
        heightCm: parseInt(this.formValues.heightCm),
        heightFt: imperialHeight.heightFt,
        heightIn: imperialHeight.heightIn,
        firstName: this.formValues.firstName.trim(),
        targetWeightKg: this.formValues.targetWeightKg,
        targetWeightLbs: this.formValues.targetWeightLbs,
      }
    } else {
      return {
        age: parseInt(this.formValues.age),
        weightKg: round(lbsToKg(this.formValues.weightLbs)),
        weightLbs: parseInt(this.formValues.weightLbs),
        heightCm: ftInToCm({ ft: this.formValues.heightFt, inch: this.formValues.heightIn }),
        heightFt: parseInt(this.formValues.heightFt),
        heightIn: parseInt(this.formValues.heightIn),
        firstName: this.formValues.firstName.trim(),
        targetWeightKg: this.formValues.targetWeightKg,
        targetWeightLbs: this.formValues.targetWeightLbs,
      }
    }
  },
})
